import { animate, animation, style } from "@angular/animations";

export const slideCollapseAnimation = animation([
    style({
        height: '*',
        paddingTop: '*',
        paddingBottom: '*',
        marginTop: '*',
        marginBottom: '*',
        overflow: 'hidden'
    }),
    animate('{{ transition }} {{ delay }} {{ ease }}', style({
        height: '0px',
        paddingTop: '0px',
        paddingBottom: '0px',
        marginTop: '0px',
        marginBottom: '0px',
    }))
], {
    params: {
        transition: '400ms',
        delay: '0ms',
        ease: 'ease-in-out'
    }
});

export const slideExpandAnimation = animation([
    style({
        height: '0px',
        paddingTop: '0px',
        paddingBottom: '0px',
        marginTop: '0px',
        marginBottom: '0px',
        overflow: 'hidden'
    }),
    animate('{{ transition }} {{ delay }} {{ ease }}', style({
        height: '*',
        paddingTop: '*',
        paddingBottom: '*',
        marginTop: '*',
        marginBottom: '*',
    }))
], {
    params: {
        transition: '400ms',
        delay: '0ms',
        ease: 'ease-in-out'
    }
})